/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import './style.css'
import CustomerWiseShipmentBarChart from './CustomerWiseShipmentBarChart'
import NetProfitLineChart from './NetProfitLineChart'
import DeliveryRegionDonutChart from './DeliveryRegionDonutChart'
import {Dropdown} from 'react-bootstrap'
import 'react-date-range/dist/styles.css' // main css file
import 'react-date-range/dist/theme/default.css' // theme css file
import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import DateRanger from './DateRanger'
import clsx from 'clsx'
import DamageLostPieChart from './GPSPieChart'
import OnTimeAndLatePieChart from './OnTimeAndLatePieChart'
import Flag from 'react-world-flags'
import {useSelector} from 'react-redux'
import {useGetAdminRowOneQuery} from '../../redux/network/AdminDashboardApi'

interface DashboardPageProps {
  currency: string
  gridData: {
    totalRevenue: number
    totalCost: number
    totalProfit: number
    totalShipments: number
    totalKMs: number
    costPerKm: number
    totalHelpUpPickUp: number
    totalHeldUpDelivery: number
    averageHeldUpTime: number
  }
  isFiltered: boolean
}

interface DashboardWrapperProps {
  currency: string
}

const DashboardPage: FC<DashboardPageProps> = ({currency, gridData , isFiltered}) => (
  <>
    <div className=''>
      <div
        className='d-flex flex-wrap flex-stack py-2 ps-3 rounded mb-3'
        style={{
          background: '',
          // background: 'linear-gradient(to right, #1e1e2d , #f5f8fa)',
        }}
      >
        <div className='d-flex align-items-start d-flex flex-column'>
          <h1 className='text-dark fw-bold my-1'>Main Dashboard</h1>
          <p className='text-gray-500 fw-semibold fs-5 mb-0'>
            Real-Time Vehicle Performance Overview
          </p>
        </div>

        <div className='d-flex justify-content-end px-2'>
          <div className='m-0'>
            <a
              href='#'
              className={`btn btn-sm btn-flex fw-semibold bg-white ms-3 border border-1 border-gray-300 py-3
                ${isFiltered 
                  ? 'bg-danger text-white' 
                  : 'text-gray-600 bg-hover-danger text-hover-white'
                }`}
              data-kt-menu-trigger='click'
              data-kt-menu-placement='bottom-end'
            >
              <KTSVG
                path='/media/icons/duotune/general/gen031.svg'
                className=  {`svg-icon-6 ${isFiltered ? 'text-white' : 'svg-icon-danger'} me-3`}
              />
              Filter
            </a>
            <DateRanger />
          </div>
        </div>
      </div>

      <div className='mx-2 mb-2'>
        <div className='row gx-4 gy-2'>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card w-100 mb-xl-2 '
              // card-xl-stretch
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
                // background:
                //   'linear-gradient(-120deg, rgba(97, 67, 133, 1) 60%, rgba(81, 99, 149, 1) 100%)',
                // minWidth: '400px',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  <div className='rounded small-card-img '>
                    <div className='symbol symbol-50px p-1 bg-light-danger me-4'>
                      <KTSVG
                        path='/media/icons/duotune/graphs/gra012.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center'>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Revenue
                      </span>
                      {/* <div className='d-flex align-items-center'>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr003.svg'
                          className='svg-icon-1 svg-icon-success me-2'
                        />
                        <div className='card-title-sub fw-bolder text-success'>3.5%</div>
                      </div> */}
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {currency}{' '}
                        {gridData.totalRevenue.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card w-100 mb-xl-2 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='media/icons/duotune/graphs/gra003.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Cost
                      </span>
                      {/* <div className='d-flex align-items-center'>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr066.svg'
                          className='svg-icon-1 svg-icon-white me-2'
                        />
                        <div className='card-title-sub fw-bolder text-danger'>3%</div>
                      </div> */}
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {currency}{' '}
                        {currency === 'LKR'
                          ? (gridData.totalCost * 0.01834).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : gridData.totalCost.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card w-100 mb-xl-2 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/graphs/gra001.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Profit/Loss
                      </span>
                      {/* <div className='d-flex align-items-center'>
                        <KTSVG
                          path='/media/icons/duotune/arrows/arr004.svg'
                          className='svg-icon-1 svg-icon-danger me-2'
                        />
                        <div className='fs-2 fw-bolder text-danger'>3%</div>
                      </div> */}
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {currency}{' '}
                        {currency === 'LKR'
                          ? (1400000 * 0.01834).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : gridData.totalProfit.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card w-100 mb-xl-2'
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/finance/fin006.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Shipments
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {gridData.totalShipments}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/graphs/gra005.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total KMs
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {gridData.totalKMs.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/ecommerce/ecm006.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Cost Per KM
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {currency}{' '}
                        {currency === 'LKR'
                          ? (gridData.costPerKm * 0.01834).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : gridData.costPerKm.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className='col-lg-12 col-xl-6 col-xxl-6'>
            <div className='card mb-4 w-100   -lg'>
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between mt-2 w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        On Time - 560 / <span className='ms-1 text-danger'> Late - 4</span>
                      </span>
                    </div>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mb-2'>
                        Total Delivery Status Count
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-6'>
            <div className='card mb-4 w-100   -lg'>
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  {' '}
                  <div className='rounded small-card-img '>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger '>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center '>
                    <div className='d-flex justify-content-between mt-2 w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        On Time - 98.0% / <span className='ms-1 text-danger'> Late - 2.0% </span>
                      </span>
                    </div>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mb-2'>
                        Total Delivery Status Percentage
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center'>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Held Up Time (Pickup)
                      </span>
                    </div>
                    <div className='d-flex justify-content-between w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {gridData.totalHelpUpPickUp.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}{' '}
                        Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center'>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Total Held Up Time (Delivery)
                      </span>
                    </div>
                    <div className='d-flex justify-content-between w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {gridData.totalHeldUpDelivery.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-12 col-xl-12 col-xxl-4'>
            <div
              className='card mb-xl-2 w-100 '
              style={{
                border: '1px solid rgba(236, 111, 102, 0.1)',
              }}
            >
              <div className='card-body small-card-padding rounded'>
                <div className='d-flex align-items-center flex-w'>
                  <div className='rounded small-card-img'>
                    <div className='symbol symbol-50px me-4 p-1 bg-light-danger'>
                      <KTSVG
                        path='/media/icons/duotune/general/gen013.svg'
                        className='svg-icon-danger svg-icon-3hx'
                      />
                    </div>
                  </div>
                  <div className='d-flex flex-column w-100 text-start align-items-center'>
                    <div className='d-flex justify-content-between flex-1 w-100'>
                      <span className='card-title-sub fw-semibold text-gray-600 mt-2 mt-lg-0'>
                        Average Held Up Time
                      </span>
                    </div>
                    <div className='d-flex justify-content-between  w-100'>
                      <span
                        className='d-flex align-items-center card-titles'
                        style={{fontWeight: 600}}
                      >
                        {gridData.averageHeldUpTime.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })} Hours
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='mx-2'>
        <div className='row gx-4 gy-2'>
          <div className='col-lg-12 col-xl-12 col-xxl-12'>
            {' '}
            <CustomerWiseShipmentBarChart currency={currency} />
          </div>

          <div className='col-lg-12 col-xl-12 col-xxl-12'>
            {' '}
            <NetProfitLineChart />
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-6'>
            {' '}
            <OnTimeAndLatePieChart />
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-6'>
            {' '}
            <DamageLostPieChart />
          </div>
          <div className='col-lg-12 col-xl-6 col-xxl-12'>
            {' '}
            <DeliveryRegionDonutChart currency={currency} />
          </div>
        </div>
      </div>
    </div>
  </>
)

const DashboardWrapper: FC<DashboardWrapperProps> = ({currency}) => {
  const {startDate, endDate, customers, isFiltered} = useSelector(
    (state: any) => state.Filter.Filter
  )
  const {data: rowData, error: rowError} = useGetAdminRowOneQuery(
    {startDate, endDate, customers},
    {
      refetchOnMountOrArgChange: true,
      pollingInterval: isFiltered ? 0 : 10000,
      skip: false,
    }
  )

  const gridData = {
    totalRevenue: rowData?.totalRevenue ?? 0,
    totalCost: rowData?.totalCost ?? 0,
    totalProfit: rowData?.totalProfit ?? 0,
    totalShipments: rowData?.totalShipments ?? 0,
    totalKMs: rowData?.totalKms ?? 0,
    costPerKm: rowData?.costPerKm ?? 0,
    totalHelpUpPickUp: rowData?.totalHelpUpPickUp ?? 0,
    totalHeldUpDelivery: rowData?.totalDeliverySpend ?? 0,
    averageHeldUpTime: rowData?.averageHeldUpTime ?? 0,
  }

  return (
    <>
      <DashboardPage currency={currency} gridData={gridData} isFiltered={isFiltered} />
    </>
  )
}

export {DashboardWrapper}
